import { render } from "./AssetFinancePage.vue?vue&type=template&id=068c68fe"
import script from "./AssetFinancePage.vue?vue&type=script&lang=js"
export * from "./AssetFinancePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__